import { FC } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import styles from './styles.module.scss';
import { QUERY_KEYS } from '@/common/api/config';
import { useIsMobile } from '@/common/hooks/useIsMobile';
import { LogoutIcon } from '@/common/icons/LogoutIcon';
import { ALERT_TEXT_COLOR, GRAY_COLOR } from '@/styles/colorsJS';

interface Props {
  handler?: () => void;
}

export const Logout: FC<Props> = ({ handler }) => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const handleLogOut = async () => {
    if (handler) handler();
    localStorage.clear();
    queryClient.removeQueries({ queryKey: [QUERY_KEYS.REG_STEP, null] });
    navigate('/');
  };

  return (
    <button
      id="logout-button"
      className={styles.logoutButton}
      onClick={handleLogOut}
    >
      <LogoutIcon color={isMobile ? ALERT_TEXT_COLOR : GRAY_COLOR} />
      <FormattedMessage defaultMessage="Выйти из аккаунта" />
    </button>
  );
};
